import store from "../../index.js";
import AnalyzeConstant from '@/mixins/analyze/const/analyzeConstant.js';
import AnalyzeAcConstant from '@/mixins/analyze/const/analyzeAcConstant.js';
import api from "../../../utils/api.js";

export const modules = {
    store,
};

export const state = {
  _items: [],
  _error: {
    code: 0,
    message: "",
  },
};

export const mutations = {  
    [AnalyzeConstant.SET_ANALYZE_ERROR](state, item) {
        state._error = item;
    },
    [AnalyzeConstant.SET_ANALYZE_CONTINUE_ITEMS](state, items) {
        state._items = items;
    },
};

export const actions = {
    async acAnalyzeContinueReport({ commit }) {
        const url = AnalyzeAcConstant.GET_ANALYZE_CONTINUE_REPORT;
        try {
            const res = await api.get(url);
            if(res.data?.code === 0){
                commit(AnalyzeConstant.SET_ANALYZE_CONTINUE_ITEMS, res.data?.data);
            }            
            return res.data?.code === 0;
        } 
        catch(error) {                 
            commit(AnalyzeConstant.SET_ANALYZE_ERROR, error.response.data);
            return false;
        }
    }, 
    async acAnalyzeContinueSubscribe({ commit }) {
        const url = AnalyzeAcConstant.GET_ANALYZE_CONTINUE_SUBSCRIBE;
        try {
            const res = await api.get(url);
            if(res.data?.code === 0){
                commit(AnalyzeConstant.SET_ANALYZE_CONTINUE_ITEMS, res.data?.data);
            }            
            return res.data?.code === 0;
        } 
        catch(error) {                 
            commit(AnalyzeConstant.SET_ANALYZE_ERROR, error.response.data);
            return false;
        }
    }, 
};

export const getters = {
    geCodeFail: state => {
        switch(state._error.code){
            case 0: return '';
        }  
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};